"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  CURRENCY: null,
  DATETIME: null,
  DATE: null,
  LINK: null,
  EMAIL: null,
  NUMERIC: null,
  STRING: null,
  STATUS: null
});

exports.default = _default;
module.exports = exports.default;